<template>

    <div>
        <WaitingPrice
            :entity-type="BUSINESS_TYPE.GROCER"
            :entity-id="+$route.params.id"
        >
            <template v-slot:tabs>
                <GrocerTabLinks />
            </template>
        </WaitingPrice>
    </div>

</template>

<script>
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import WaitingPrice from '@/components/waiting-price/WaitingPrice';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityWaitingPrice',

        components: {
            GrocerTabLinks,
            WaitingPrice
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
